import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const publishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

if (!url || !publishableKey) {
  throw new Error(
    "VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY must be set.",
  );
}

// The publishable key ships inside this bundle on purpose: it identifies the
// project, it is not a secret. It grants nothing on its own -- the `quest`
// schema is not exposed to the Data API, and `anon` holds no privileges on it,
// so every read and write has to go through the function.
export const supabase = createClient(url, publishableKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});

export const functionsBaseUrl = `${url.replace(/\/$/, "")}/functions/v1/api`;
